export interface DocumentType {
  code: string;
  id: number;
  name: string;
}
